import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-[#1F2937] text-[#E9EAE8] pt-12 px-4 md:px-8 border-t-4 border-[#566D87] w-full">
      <div className="w-full max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8 w-full text-center">
          {/* Column 1: Logo and description */}
          <div className="space-y-4 mx-auto">
            <h2 className="text-2xl font-bold text-[#E9EAE8]">
              <span className="text-[#566D87]">LASER</span> ZONE
            </h2>
            <p className="text-sm text-[#6A706C] max-w-xs mx-auto">
              Experience the ultimate laser game adventure. Professional arenas, 
              state-of-the-art equipment, and pure adrenaline.
            </p>
          </div>

          {/* Column 2: Contact */}
          <div className="mx-auto">
            <h3 className="text-lg font-semibold mb-4 text-[#E9EAE8]">Contact</h3>
            <ul className="space-y-3 text-[#6A706C]">
              <li className="flex items-center gap-2 justify-center">
                <FaMapMarkerAlt className="text-[#566D87]" />
                <span>Laser Street 123, Future City</span>
              </li>
              <li className="flex items-center gap-2 justify-center">
                <FaPhone className="text-[#566D87]" />
                <span>+1 234 567 890</span>
              </li>
              <li className="flex items-center gap-2 justify-center">
                <FaEnvelope className="text-[#566D87]" />
                <span>info@laserzone.com</span>
              </li>
            </ul>
          </div>

          {/* Column 3: Social Media */}
          <div className="mx-auto">
            <h3 className="text-lg font-semibold mb-4 text-[#E9EAE8]">Follow Us</h3>
            <div className="flex gap-4 text-2xl justify-center">
              <a href="#" className="text-[#6A706C] hover:text-[#566D87] transition-colors duration-300">
                <FaFacebook />
              </a>
              <a href="#" className="text-[#6A706C] hover:text-[#566D87] transition-colors duration-300">
                <FaInstagram />
              </a>
              <a href="#" className="text-[#6A706C] hover:text-[#566D87] transition-colors duration-300">
                <FaTwitter />
              </a>
            </div>
          </div>
        </div>

        {/* Divider and copyright */}
        <div className="border-t border-[#141318] pt-6 pb-4 text-center w-full">
          <p className="text-sm text-[#6A706C]">
            &copy; {new Date().getFullYear()} Laser Zone Arena. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;